<script>

import {
  authMethods,
  notificationMethods,
} from "@/state/helpers";

import appConfig from "@/app.config";

/**
 * Login component
 */
export default {
  page: {
    title: "Login",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      email: "",
      password: "",
      showPassword: false,
      submitted: false,
      authError: '',
      tryingToLogIn: false,
      isAuthError: false,
      rules: {
        email: [
          v => !!v || 'E-mail is required',
          v => /.+@.+\..+/.test(v) || 'E-mail must be valid.',
        ],
        password: [
          v => !!v || 'Password is required.',
          v => (v && v.length >= 3) || 'First name must be least 6 characters.',
        ],
      }
    };
  },
  computed: {
    notification() {
      return this.$store ? this.$store.state.notification : null;
    },
  },
  
//   beforeDestroy(){
// window.location.reload()
//   },
  // beforeRouteLeave(to,from,next){
  //   window.location.reload()
  //   next()
  // },
  methods: {
    ...authMethods,
    ...notificationMethods,
    // Try to log the user in with the username
    // and password they provided.
    signIn() {
      // stop here if form is invalid
      if (this.validate()) {
        this.submitted = true;
        this.authError = '';
        this.tryingToLogIn = true;
        this.login({email: this.email, password: this.password})
            // eslint-disable-next-line no-unused-vars
            .then((data) => {
              this.submitted = false;
              this.tryingToLogIn = false;
              this.isAuthError = false;
              this.authError = '';
              // Redirect to the originally requested page, or to the home page
              if(data.freight_partner != null){
                this.$router.push(
                   {
                    name: "freights-list",
                  }
              );              }else{
                this.$router.push(
                   {
                    name: "dashboards",
                  }
              );
              }
            })
            .catch(err => {
              this.submitted = false;
              this.tryingToLogIn = false;
              this.authError = 'Error! try again later';
              if ('response' in err) {
                if (err.response.status === 422) {
                  this.authError = '';
                  const errors = err.response.data;
                  if ('message' in errors) {
                    this.authError = errors.message;
                  } else {
                    Object.values(errors).forEach(validations => {
                      validations.forEach(validation => {
                        this.authError += `${validation}<br>`;
                      })
                    })
                  }
                } else if (err.response.status !== 500
                    || ('data' in err.response.data && 'message' in err.response.data.data)
                ) {
                  this.authError = err.response.data.data.message;
                }
              }
              this.isAuthError = true;
            })
      }
    },
    validate () {
      return this.$refs.form.validate()
    },
    reset () {
      this.$refs.form.reset()
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    },
  },
  mounted() {},
  
};
</script>

<template>
  <div class="fill-height">
    <v-container fluid id="login" class="m-0 p-0">
      <v-row class="px-0 d-flex flex-row fill-height">
        <v-col class="navy d-none d-md-flex" md="6">
          <div class="logo d-flex">
            <img src="@/assets/images/logo-light.png" alt="WeStore">
          </div>
          <v-row class="row-content d-flex flex-column justify-start align-center">
            <v-col class="d-flex" cols="12" md="10">
              <h1 class="text-h2 font-weight-bold pink--text">Login</h1>
            </v-col>
            <v-col cols="12" md="10">
              <p class="text-h3 font-weight-bold white--text">Enter the portal to experience logistics made easy.</p>
            </v-col>
          </v-row>
        </v-col>
        <v-col class="d-flex">
          <div class="logo d-flex d-md-none">
            <a href="/">
              <img src="@/assets/images/logo-dark.png" alt="WeStore">
            </a>
          </div>
          <div class="home d-flex">
            <a href="/">
              <v-icon x-large>
                mdi-home-outline
              </v-icon>
            </a>
          </div>
          <v-row class="form-content d-flex flex-column justify-start align-center">
            <v-col class="col-xs-12 col-md-10">
              <v-card flat>
                <v-container class="container-bg">
                  <v-form ref="form" @submit.prevent="signIn">
                    <v-text-field v-model="email" type="text" label="Email" required
                                  :rules="rules.email"></v-text-field>
                    <v-text-field
                        v-model="password"
                        :append-icon=" showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="showPassword ? 'text': 'password'"
                        label="Password"
                        @click:append="showPassword = !showPassword"
                        :rules="rules.password"
                    ></v-text-field>
                    <v-btn :loading="submitted" type="submit" block color="pink_secondary" class="font-weight-bold mb-3 white--text">Login</v-btn>
                    <router-link :to="{name: 'Forgot password'}" class="font-weight-bold mb-3">Forgot password?</router-link>
                    <router-link :to="{name: 'Register'}"  block color="primary" class="pink--text font-weight-bold"> or Don't Have An Account ?</router-link>
                  </v-form>
                </v-container>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
        <v-snackbar
            color="red accent-2"
            elavation="24"
            top
            right
            v-model="isAuthError"
        >
          <div v-html="authError"></div>
        </v-snackbar>
      </v-row>
    </v-container>
  </div>
</template>

<style>
#login {
  height: 100%;
  min-width: 100%!important;
}

.row-content, .form-content {
  margin-top: 40%;
}
.logo {
  position: absolute;
  width: 180px;
  left: 20px;
  top: 5px;
}

.logo img {
  width: 100%;
}

.home {
  position: absolute;
  right: 20px;
  top: 5px;
  font-size: 50px;
}

.v-footer
{
  display: none !important;
}
.container-bg{
 background-color: #F0F0F5;
}
</style>
